import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: '',
    strengthIntro: ''
  },
  mutations: {
    increment (state, n) {
      console.log(n)
      state.query = n
    },
    isActive1 (state, n) {
      state.isActive1 = n
    },
    isActive2 (state, n) {
      state.isActive2 = n
    },
    isActive3 (state, n) {
      state.isActive3 = n
    },
    isActive4 (state, n) {
      state.isActive4 = n
    },
    isActive5 (state, n) {
      state.isActive5 = n
    }
  },
  actions: {
    increment ({commit}, n) {
      commit('increment', n)
    },
    isActive1 ({commit}, n) {
      commit('isActive1', n)
    },
    isActive4 ({commit}, n) {
      commit('isActive4', n)
    }
  },
  getters: {
    query (state) {
      return state.query
    },
    strengthIntro (state) {
      return state.strengthIntro
    },
    isActive4 (state) {
      return state.isActive4
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js